import {
  faUsers,
  faMobileScreen,
  faHeadset,
  faChartLine,
  faPlus,
  faClock,
  faCircleCheck,
  faArrowTrendUp,
  faArrowTrendDown,
} from '@fortawesome/free-solid-svg-icons';
import { MetricCardConfig } from './types';

export const ACTIVITY_ICON_MAP: Record<string, typeof faUsers> = {
  merchant: faUsers,
  device: faMobileScreen,
  system: faCircleCheck,
  default: faClock,
};

export const TREND_ICONS = {
  up: faArrowTrendUp,
  down: faArrowTrendDown,
} as const;

export const METRIC_TYPES = {
  TOTAL_MERCHANTS: 'totalMerchants',
  ACTIVE_DEVICES: 'activeDevices',
  SUPPORT_TICKETS: 'supportTickets',
} as const;

export const DASHBOARD_ROUTES = {
  MERCHANTS: '/merchants',
  DEVICES: '/devices',
  SUPPORT: '/help-support',
  ANALYTICS: '/analytics',
} as const;

export const SECTION_TITLES = {
  ADMIN_DASHBOARD: 'Admin Dashboard',
  QUICK_ACTIONS: 'Quick Actions',
  RECENT_ACTIVITIES: 'Recent Activities',
  SYSTEM_HEALTH: 'System Health',
  MERCHANTS_OVERVIEW: 'Merchants Overview',
  ACTIVE_DEVICES: 'Active Devices',
} as const;

export const LABELS = {
  SUBTITLE: "Welcome back! Here's what's happening with your platform.",
  SYSTEM_STATUS: 'System Status: Online',
  LOADING: 'Loading dashboard...',
  LIVE: 'Live',
  REFRESH: 'Refresh',
  VIEW_ALL: 'View All',
  NO_ACTIVITIES: 'No recent activities',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
} as const;

export const QUICK_ACTIONS_CONFIG = [
  { key: 'addMerchant', label: 'Add Merchant', icon: faPlus, route: '/merchants', color: '#2D6CCA' },
  { key: 'manageDevices', label: 'Manage Devices', icon: faMobileScreen, route: '/devices', color: '#38a169' },
  { key: 'support', label: 'Support', icon: faHeadset, route: '/help-support', color: '#ED8936' },
  { key: 'analytics', label: 'Analytics', icon: faChartLine, route: '/analytics', color: '#805AD5' },
] as const;

export const METRIC_CARDS_CONFIG: MetricCardConfig[] = [
  {
    key: METRIC_TYPES.TOTAL_MERCHANTS,
    title: 'Total Merchants',
    icon: faUsers,
    iconColor: '#2D6CCA',
    trend: 'up',
    trendValue: '+12% this month',
    subtitle: 'Active business partners',
  },
  {
    key: METRIC_TYPES.ACTIVE_DEVICES,
    title: 'Active Devices',
    icon: faMobileScreen,
    iconColor: '#48BB78',
    trend: 'up',
    trendValue: '+8% this week',
    subtitle: 'Connected kiosks',
  },
  {
    key: METRIC_TYPES.SUPPORT_TICKETS,
    title: 'Support Tickets',
    icon: faHeadset,
    iconColor: '#ED8936',
    trend: 'down',
    trendValue: '-3% this week',
    subtitle: 'Pending resolution',
  },
];

export const MERCHANT_TABLE_COLUMNS = ['Merchant Name', 'Email', 'Phone', 'Status'];
export const DEVICE_TABLE_COLUMNS = ['Device Name', 'Identifier', 'Type', 'Status'];

export const SYSTEM_HEALTH_DEFAULTS = {
  uptime: 99.9,
  apiResponse: 245,
  database: 'Healthy',
} as const;

export const SYSTEM_HEALTH_LABELS = {
  SERVER_UPTIME: 'Server Uptime',
  API_RESPONSE: 'API Response',
  DATABASE: 'Database',
} as const;

export const AUTO_REFRESH_INTERVAL = 30000;

export const SUPPORT_TICKETS_VALUE = '5';
